<template>
  <VpFormLayout>
    <template v-slot:content-header>
      <PageHeader className="d-flex align-items-center" :title="title" />
    </template>

    <template v-slot:content-body>
      <div class="addMode-form">
        <div class="form-group m-d-gruop inputs-width form">
          <vp-input
            id="name"
            v-model.trim="modeName"
            :label="$t('attendanceModes.form.modeName')"
            maxlength="20"
            width="416"
            @input="debouncedCheckDuplicateName"
            :invalid="!isAvailable"
          />
          <div v-if="!isAvailable" class="error-message">
            {{ $t("attendanceModes.form.modeNameAlreadyExistsTryDiffrentOne") }}
          </div>
        </div>

        <div class="days-options">
          <span class="wokring-days-label" v-if="daysValue && daysValue.length">
            {{ $t("attendanceModes.form.scheduleDays") }}
          </span>
          <treeselect
            v-model="daysValue"
            class="days-treeselect"
            @input="changeWorkingDaysVal"
            :multiple="true"
            :options="workingDaysOptions"
            :clearOnSelect="true"
            :flat="true"
            :default-expand-level="0"
            :placeholder="$t('attendanceModes.form.scheduleDays')"
          />
        </div>

        <div
          class="d-flex inputs-width allowSigninBeforeAfterTimeSection"
          :class="{ disabledValue: !daysValue.length }"
        >
          <b-form-checkbox
            v-model="AllowOnlySpecifiedDays"
            :disabled="!daysValue.length"
            class="check-host-button allowSigninBeforeAfterTimeLabel"
            name="AllowOnlySpecifiedDays"
            >{{
              $t("attendanceModes.form.allowOnlyToSignInOnTheSpecifiedDays")
            }}</b-form-checkbox
          >
        </div>

        <div class="d-flex inputs-width timepicker-inputs">
          <div :class="{ disabledValue: has_reasons }">
            <span class="from-to-label-one" v-if="fromTime">{{
              $t("attendanceModes.from")
            }}</span>
            <date-picker
              id="from_time"
              class="pre-reg-datepicker timepicker-width mr-14"
              :class="{ 'selected-date-value': fromTime }"
              :use12h="true"
              :show-second="false"
              format="hh:mm A"
              value-type="date"
              type="time"
              :placeholder="$t('attendanceModes.from')"
              v-model="fromTime"
              @input="changeFromTimeMode"
              :disabled="has_reasons"
            >
              <i slot="icon-calendar">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                    :fill="fromTime ? '#103F5E' : '#787878'"
                  />
                </svg>
              </i>
            </date-picker>
          </div>

          <div :class="{ disabledValue: !fromTime || has_reasons }">
            <span class="from-to-label-one" v-if="toTime">{{
              $t("attendanceModes.to")
            }}</span>
            <date-picker
              id="to_time"
              class="pre-reg-datepicker timepicker-width"
              :use12h="true"
              :class="{ 'selected-date-value': toTime }"
              :show-second="false"
              format="hh:mm A"
              value-type="date"
              type="time"
              :placeholder="$t('attendanceModes.to')"
              v-model="toTime"
              :disabled="!fromTime || has_reasons"
              @input="changeToTimeMode"
              :disabled-time="toStartTime"
              :default-value="defaultToTime"
            >
              <i slot="icon-calendar">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                    :fill="toTime ? '#103F5E' : '#787878'"
                  />
                </svg>
              </i>
            </date-picker>
          </div>
        </div>

        <p
          v-if="checkIfToDateIsBiggerThanFromDate"
          class="vp-width-381 vp-color-grey-3 vp-ml-18 vp-mt-8"
        >
          <b>{{ $t("common.notes.note") }}:</b> This mode will be applied until
          {{ format_date(toTime) }} the next day for the specified days.
        </p>

        <div
          class="d-flex inputs-width allowSigninBeforeAfterTimeSection"
          :class="{ disabledValue: !fromTime || !toTime }"
        >
          <b-form-checkbox
            v-model="preventSigninBeforeStartTime"
            :disabled="!fromTime || !toTime"
            class="check-host-button allowSigninBeforeAfterTimeLabel"
            name="preventSigninBeforeStartTime"
            >{{
              $t("attendanceModes.form.preventSignInBeforeTheStartTime")
            }}</b-form-checkbox
          >
        </div>

        <div
          class="d-flex inputs-width preventSigninAfterEndTimeSection"
          :class="{ disabledValue: !fromTime || !toTime }"
        >
          <b-form-checkbox
            v-model="preventSigninAfterEndTime"
            :disabled="!fromTime || !toTime"
            class="check-host-button allowSigninBeforeAfterTimeLabel"
            name="preventSigninAfterEndTime"
            >{{
              $t("attendanceModes.form.preventSignInAfterTheEndTime")
            }}</b-form-checkbox
          >
        </div>

        <!-- integrations dropdown list -->
        <div class="d-flex">
          <div
            v-if="getWondeIntegrations && getWondeIntegrations.length"
            class="integrations-options"
            :class="{ disabledValue: has_reasons }"
          >
            <!-- <span class="integrations-label" v-if="integrationValue"> Integration (Optional) </span>
                      <treeselect v-model="integrationValue" class="integrations-treeselect selectIntegration" :options="getWondeIntegrations" :clearOnSelect="true"
                      :default-expand-level="0" placeholder="Integration (Optional)" @select="changeIntegrationValue" :disabled="has_reasons"/> -->

            <VpMultiselect
              class="mr-32 selectIntegration"
              zIndex="120"
              :showPlaceholderIcon="true"
              width="416"
              :showOptionsBorder="true"
              :showNoResults="true"
              v-model="integrationValue"
              label="label"
              :options="getWondeIntegrations"
              :allowEmpty="true"
              :show-labels="false"
              :title="$t('attendanceModes.form.integrationOptional')"
              :disabled="has_reasons"
              :isLoading="integrationsLoading"
              noResultMessage="No results found"
              @input="changeIntegrationValue"
            />
          </div>
          <!-- <div
            v-if="integrationsLoading"
            style="z-index: 999"
            class="spinner-border"
            role="status"
          ></div> -->
        </div>

        <div class="addMode-seperator-line"></div>
        <h6 class="mode-settings-label">
          {{ $t("attendanceModes.form.signInSettings") }}
        </h6>
        <div
          class="d-flex inputs-width mt-32"
          :class="{ disabledValue: has_reasons }"
        >
          <b-form-checkbox
            @change="changeAllowLateSignin"
            v-model="AllowLateSignin"
            class="check-host-button signinStartTimeLabel"
            name="check-button"
            :disabled="has_reasons"
            >{{
              $t(
                "attendanceModes.form.allowLateSignInWithoutReasonAfterStartTimeBy"
              )
            }}</b-form-checkbox
          >

          <div
            class="signin-minutes"
            :class="{ disabledValueTwo: !AllowLateSignin || has_reasons }"
          >
            <div
              class="d-flex signin-start-time"
              :class="{ 'invalid-value-attendance': minStartTimeModeError }"
            >
              <div class="timer-con">
                <input
                  v-model="signinToStartInMinutes"
                  :disabled="!AllowLateSignin || has_reasons"
                  class="form-control signin-minutes-input"
                  type="number"
                  :min="defaultSigninToStartInMinutes"
                  pattern="\d*"
                  required
                  @input="changeMinStartTimeMode"
                />
              </div>

              <div class="minutes-label">
                <div class="minutes">{{ $t("common.minutes") }}</div>
              </div>
            </div>
            <div v-if="!minStartTimeModeError" class="signin-out-note">
              <b>{{ $t("common.notes.note") }}:</b>
              {{ $t("common.validation.valueCantBeLessThan1Minute") }}
            </div>
            <div
              v-else
              class="signin-out-error"
              v-text="minStartTimeModeErrorMessage"
            ></div>
          </div>
        </div>

        <!-- On Time Attendance Code with integrations exsits -->
        <div v-if="integrationValue" class="integrations-options mb-20">
          <VpMultiselect
            class="mr-32"
            zIndex="120"
            :showPlaceholderIcon="true"
            width="416"
            :showOptionsBorder="true"
            :showNoResults="true"
            v-model="signinAttendanceCodeValue"
            label="label"
            :options="attendanceCodeSigninOptions"
            :allowEmpty="true"
            :show-labels="false"
            :title="$t('attendanceModes.form.onTimeAttendanceCodeOptional')"
            :disabled="integrationsLoading"
            noResultMessage="No results found"
            @input="changeSignInCodeValue"
          />
        </div>

        <div v-if="integrationValue" class="codes-signin-out-note">
          <b>{{ $t("common.notes.note") }}:</b>
          {{
            $t("attendanceModes.form.defaultAttendanceCodeAppliedDuringSignIn")
          }}
        </div>

        <h6 class="mode-settings-label mt-40">
          {{ $t("attendanceModes.form.signOutSettings") }}
        </h6>
        <div
          class="d-flex inputs-width mt-32"
          :class="{ disabledValue: has_reasons }"
        >
          <b-form-checkbox
            @change="changeAllowEarlySignout"
            v-model="AllowEarlySignout"
            :disabled="has_reasons"
            class="check-host-button signinStartTimeLabel"
            name="check-button"
            >{{
              $t(
                "attendanceModes.form.allowEarlySignOutWithoutReasonBeforeEndTimeBy"
              )
            }}</b-form-checkbox
          >

          <div
            class="signin-minutes"
            :class="{ disabledValueTwo: !AllowEarlySignout || has_reasons }"
          >
            <div
              class="d-flex signin-start-time"
              :class="{ 'invalid-value-attendance': minEndTimeModeError }"
            >
              <input
                :disabled="!AllowEarlySignout"
                v-model="signoutToEndInMinutes"
                class="form-control signin-minutes-input"
                type="number"
                :min="defaultSignoutToEndInMinutes"
                pattern="\d*"
                required
                @input="changeMinEndTimeMode"
              />
              <div class="input-border-wrapper">
                <div class="input-border"></div>
              </div>
              <div class="minutes-label">
                <div class="minutes">{{ $t("common.minutes") }}</div>
              </div>
            </div>
            <div v-if="!minEndTimeModeError" class="signin-out-note">
              <b>{{ $t("common.notes.note") }}:</b>
              {{ $t("common.validation.valueCantBeLessThan1Minute") }}
            </div>
            <div
              v-else
              class="signin-out-error"
              v-text="minEndTimeModeErrorMessage"
            ></div>
          </div>
        </div>

        <!-- On Time Attendance Code with integrations exsits -->
        <div v-if="integrationValue" class="integrations-options mb-20">
          <VpMultiselect
            class="mr-32"
            zIndex="120"
            :showPlaceholderIcon="true"
            width="416"
            :showOptionsBorder="true"
            :showNoResults="true"
            v-model="signoutAttendanceCodeValue"
            label="label"
            :options="attendanceCodeSignoutOptions"
            :allowEmpty="true"
            :show-labels="false"
            :title="$t('attendanceModes.form.onTimeAttendanceCodeOptional')"
            :disabled="integrationsLoading"
            noResultMessage="No results found"
            @input="changeSignOutCodeValue"
          />
        </div>

        <div v-if="integrationValue" class="codes-signin-out-note">
          <b>{{ $t("common.notes.note") }}:</b>
          {{
            $t("attendanceModes.form.defaultAttendanceCodeAppliedDuringSignOut")
          }}
        </div>
      </div>
    </template>

    <template v-slot:content-footer>
      <VpButton
        :text="action"
        :disabled="
          !getIsAvailable ||
          !modeName ||
          !daysValue.length ||
          !fromTime ||
          !toTime ||
          minStartTimeModeError ||
          minEndTimeModeError
            ? true
            : AllowEarlySignout && !signoutToEndInMinutes
            ? true
            : AllowLateSignin && !signinToStartInMinutes
            ? true
            : confirmAddMode
            ? true
            : false
        "
        :isLoading="confirmAddMode"
        :height="'37px'"
        :width="'151px'"
        @click="onSubmit()"
      />
    </template>
  </VpFormLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../../../components/page-header.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import debounce from "lodash/debounce";

export default {
  name: "addAttendanceModeForm",
  title: "Add Attendance Mode",
  props: {
    modeName: String,
  },
  data() {
    return {
      title: this.$t("attendanceModes.form.addMode"),
      update: false,
      action: this.$t("attendanceModes.form.addMode"),
      attendanceModeId: null,
      isAvailable: true,
      daysValue: [],
      integrationValue: null,
      integrationName: null,
      AllowEarlySignout: false,
      AllowLateSignin: false,
      AllowOnlySpecifiedDays: false,
      minStartTimeModeError: false,
      minEndTimeModeError: false,
      confirmAddMode: false,
      integrationsLoading: false,
      preventSigninBeforeStartTime: false,
      preventSigninAfterEndTime: false,
      fromTime: null,
      toTime: null,
      minStartTimeModeErrorMessage: "",
      minEndTimeModeErrorMessage: "",
      signinToStartInMinutes: 1,
      signoutToEndInMinutes: 30,
      defaultSigninToStartInMinutes: 1,
      defaultSignoutToEndInMinutes: 1,
      signinAttendanceCodeValue: null,
      signoutAttendanceCodeValue: null,
      workingDaysOptions: [
        { id: 1, label: this.$t("common.saturday") },
        { id: 2, label: this.$t("common.sunday") },
        { id: 3, label: this.$t("common.monday") },
        { id: 4, label: this.$t("common.tuesday") },
        { id: 5, label: this.$t("common.wednesday") },
        { id: 6, label: this.$t("common.thursday") },
        { id: 7, label: this.$t("common.friday") },
      ],
      integrationsOptions: [],
      attendanceCodeSigninOptions: [],
      attendanceCodeSignoutOptions: [],
      defaultToTime: null,
      tz: moment.tz.guess(),
      has_reasons: false,
      toDateIsBiggerThanFromDate: false,
    };
  },
  created() {
    this.debouncedCheckDuplicateName = debounce(this.checkModeName, 500);
  },
  components: {
    PageHeader,
    Treeselect,
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("attendanceMode", ["getAttendanceCodes", "getIsAvailable"]),
    ...mapGetters("integration", ["getWondeIntegrations"]),

    checkIfToDateIsBiggerThanFromDate() {
      if (!this.toTime || !this.fromTime) return false;
      return moment(this.toTime)?.diff(moment(this.fromTime), "minutes") > 0
        ? false
        : true;
    },
  },
  methods: {
    ...mapActions("attendanceMode", [
      "addAttendanceMode",
      "fetchAttendanceCodes",
      "editAttendanceMode",
      "checkDuplicateName",
    ]),

    checkModeName() {
      this.isAvailable = true;
      this.checkDuplicateName({
        value: this.modeName,
        entity_id: this.currentEntity.id,
        attendance_mode_id: this.update ? this.attendanceModeId : null,
      }).then((data) => {
        this.isAvailable = data.data;
      });
    },

    ...mapActions("integration", ["fetchWondeIntegrations"]),
    format_date(value) {
      if (value) return moment(value).format("hh:mm A");
    },
    toStartTime(date) {
      const selectedTime = moment(new Date(date)).format("HH:mm");
      const fromTime = moment(new Date(this.fromTime)).format("HH:mm");
      return selectedTime == fromTime;
    },
    changeWorkingDaysVal(value) {
      console.log("valueeeeee", value);
      if (!value.length) {
        this.AllowOnlySpecifiedDays = false;
      }
    },
    changeFromTimeMode(value) {
      this.minStartTimeModeErrorMessage = "";
      this.minStartTimeModeError = false;
      this.toTime = null;
      this.minEndTimeModeErrorMessage = "";
      this.minEndTimeModeError = false;
      this.defaultToTime = null;
      this.preventSigninBeforeStartTime = false;
      this.preventSigninAfterEndTime = false;
      if (value) {
        this.defaultToTime = new Date(this.fromTime.getTime());
        this.diffTimeBetweenSigninAndSignout("fromTime");
      }
    },
    disableToTime(date) {
      date = moment(date).format("HH:mm");
      let fromTime = moment(this.fromTime).format("HH:mm");
      return date === fromTime;
    },
    changeToTimeMode(value) {
      if (!value) {
        this.preventSigninBeforeStartTime = false;
        this.preventSigninAfterEndTime = false;
      }
      if (
        moment(new Date(this.fromTime)).format("HH:mm") ==
        moment(new Date(this.toTime)).format("HH:mm")
      )
        this.toTime = "";
      this.minEndTimeModeErrorMessage = "";
      this.minEndTimeModeError = false;
      this.diffTimeBetweenSigninAndSignout("fromTime");
      this.diffTimeBetweenSigninAndSignout("toTime");
    },
    changeMinStartTimeMode() {
      this.minStartTimeModeErrorMessage = "";
      this.minStartTimeModeError = false;
      if (this.signinToStartInMinutes < this.defaultSigninToStartInMinutes) {
        this.minStartTimeModeErrorMessage = `Value can’t be less than ${this.defaultSigninToStartInMinutes} minute.`;
        this.minStartTimeModeError = true;
      } else {
        this.diffTimeBetweenSigninAndSignout("startMinutes");
        this.diffTimeBetweenSigninAndSignout("endMinutes");
      }
    },
    changeMinEndTimeMode() {
      this.minEndTimeModeErrorMessage = "";
      this.minEndTimeModeError = false;
      if (this.signoutToEndInMinutes < this.defaultSignoutToEndInMinutes) {
        this.minEndTimeModeErrorMessage = `Value can’t be less than ${this.defaultSignoutToEndInMinutes} minute.`;
        this.minEndTimeModeError = true;
      } else {
        this.diffTimeBetweenSigninAndSignout("startMinutes");
        this.diffTimeBetweenSigninAndSignout("endMinutes");
      }
    },
    changeAllowEarlySignout() {
      this.minEndTimeModeError = false;
      this.signoutToEndInMinutes = 30;
      this.diffTimeBetweenSigninAndSignout("startMinutes");
      this.diffTimeBetweenSigninAndSignout("endMinutes");
    },
    changeAllowLateSignin() {
      this.minStartTimeModeError = false;
      this.signinToStartInMinutes = 1;
      this.diffTimeBetweenSigninAndSignout("startMinutes");
      this.diffTimeBetweenSigninAndSignout("endMinutes");
    },
    diffTimeBetweenSigninAndSignout(value) {
      let fromTime = "";
      let toTime = "";

      if (value == "fromTime" || value == "startMinutes") {
        this.minStartTimeModeErrorMessage = "";
        this.minStartTimeModeError = false;
      }
      if (value == "toTime" || value == "endMinutes") {
        this.minEndTimeModeErrorMessage = "";
        this.minEndTimeModeError = false;
      }

      if (this.fromTime && this.toTime) {
        fromTime = new Date(this.fromTime.getTime());
        toTime = new Date(this.toTime.getTime());

        if (fromTime > toTime) {
          toTime = new Date(toTime.setDate(toTime.getDate() + 1));
          console.log("toTime", toTime);
        }

        let startTimeWithoutMinutes = moment(fromTime, "DD-MM-YYYY hh:mm:ss");
        let endTimeWithoutMinutes = moment(toTime, "DD-MM-YYYY hh:mm:ss");

        let minutesDiffWithoutSignInOutMinutes = endTimeWithoutMinutes.diff(
          startTimeWithoutMinutes,
          "minutes"
        );
        if (
          minutesDiffWithoutSignInOutMinutes < this.signinToStartInMinutes &&
          this.AllowLateSignin &&
          (value == "startMinutes" || value == "fromTime")
        ) {
          this.minStartTimeModeErrorMessage =
            "Value can’t exceed the mode’s working hours.";
          this.minStartTimeModeError = true;
          return;
        } else if (
          minutesDiffWithoutSignInOutMinutes < this.signoutToEndInMinutes &&
          this.AllowEarlySignout &&
          (value == "endMinutes" || value == "toTime")
        ) {
          this.minEndTimeModeErrorMessage =
            "Value can’t exceed the mode’s working hours.";
          this.minEndTimeModeError = true;
          return;
        }

        console.log("Minutes1:" + minutesDiffWithoutSignInOutMinutes);

        if (this.AllowLateSignin || this.AllowEarlySignout) {
          fromTime = this.AllowLateSignin
            ? new Date(fromTime.getTime() + this.signinToStartInMinutes * 60000)
            : new Date(fromTime.getTime());
          toTime = this.AllowEarlySignout
            ? new Date(toTime.getTime() - this.signoutToEndInMinutes * 60000)
            : new Date(toTime.getTime());

          console.log("fromTime", fromTime);
          console.log("toTime", toTime);

          let startTimeWithMinutes = moment(fromTime, "DD-MM-YYYY hh:mm:ss");
          let endTimeWithMinutes = moment(toTime, "DD-MM-YYYY hh:mm:ss");

          let minutesDiffWithSignInOutMinutes = endTimeWithMinutes.diff(
            startTimeWithMinutes,
            "minutes"
          );

          console.log("Minutes2:" + minutesDiffWithSignInOutMinutes);

          if (fromTime >= toTime) {
            if (
              this.AllowLateSignin &&
              (value == "fromTime" || value == "startMinutes")
            ) {
              if (this.AllowEarlySignout) {
                this.minStartTimeModeErrorMessage =
                  "Value can’t overlap with the early sign-out time.";
              } else {
                this.minStartTimeModeErrorMessage =
                  "Value can’t overlap with the sign-out time.";
              }
              this.minStartTimeModeError = true;
              return;
            } else if (
              this.AllowEarlySignout &&
              (value == "toTime" || value == "endMinutes")
            ) {
              if (this.AllowLateSignin) {
                this.minEndTimeModeErrorMessage =
                  "Value can’t overlap with the late sign-in time.";
              } else {
                this.minEndTimeModeErrorMessage =
                  "Value can’t overlap with the sign-in time.";
              }
              this.minEndTimeModeError = true;
              return;
            }
          }
        }

        if (this.signinToStartInMinutes < this.defaultSigninToStartInMinutes) {
          this.minStartTimeModeErrorMessage = `Value can’t be less than ${this.defaultSigninToStartInMinutes} minute.`;
          this.minStartTimeModeError = true;
        } else if (
          this.signoutToEndInMinutes < this.defaultSignoutToEndInMinutes
        ) {
          this.minEndTimeModeErrorMessage = `Value can’t be less than ${this.defaultSignoutToEndInMinute} minute.`;
          this.minEndTimeModeError = true;
        }
      }
    },
    changeIntegrationValue(value) {
      if (value) {
        this.integrationsLoading = true;
        this.integrationName = value.label;
        this.fetchAttendanceCodes({ id: value.id }).then((data) => {
          this.attendanceCodeSigninOptions = data.data;
          this.attendanceCodeSignoutOptions = data.data;
          this.integrationsLoading = false;
        });
      } else {
        console.log("valueeee", value);
        this.integrationValue = null;
        this.attendanceCodeSigninOptions = [];
        this.attendanceCodeSignoutOptions = [];
        this.signinAttendanceCodeValue = null;
        this.signoutAttendanceCodeValue = null;
        this.integrationName = null;
      }
    },
    changeSignInCodeValue(value) {
      if (value) {
        if (value.id == this.signinAttendanceCodeValue) {
          this.signinAttendanceCodeValue = null;
        }
      }
    },
    changeSignOutCodeValue(value) {
      if (value) {
        if (value.id == this.signoutAttendanceCodeValue) {
          this.signoutAttendanceCodeValue = null;
        }
      }
    },
    addArrowContainer() {
      const controlArrowContainer = document.querySelector(
        ".selectIntegration .vue-treeselect__control .vue-treeselect__control-arrow-container  .vue-treeselect__control-arrow"
      );
      console.log("addArrowContainer", controlArrowContainer);
      if (controlArrowContainer)
        controlArrowContainer.classList.remove("arrowHide");
    },
    removeArrowContainer() {
      const controlArrowContainer = document.querySelector(
        ".selectIntegration .vue-treeselect__control .vue-treeselect__control-arrow-container .vue-treeselect__control-arrow"
      );
      console.log("removeArrowContainer", controlArrowContainer);
      controlArrowContainer.classList.add("arrowHide");
    },
    onSubmit() {
      this.confirmAddMode = true;
      let attendanceCodeIds = [];
      let workingDaysStrings = [];
      const {
        update,
        modeName,
        daysValue,
        fromTime,
        toTime,
        workingDaysOptions,
        signinToStartInMinutes,
        signoutToEndInMinutes,
        integrationValue,
        integrationName,
        AllowLateSignin,
        AllowEarlySignout,
        signinAttendanceCodeValue,
        signoutAttendanceCodeValue,
        AllowOnlySpecifiedDays,
        preventSigninBeforeStartTime,
        preventSigninAfterEndTime,
        addAttendanceMode,
        editAttendanceMode,
      } = this;

      daysValue.sort((a, b) => {
        return a - b;
      });
      daysValue.map((value) => {
        workingDaysOptions.map((day) => {
          if (day.id == value) {
            workingDaysStrings.push(day.label);
          }
        });
      });

      if (integrationValue) {
        if (signinAttendanceCodeValue)
          attendanceCodeIds.push({
            id: signinAttendanceCodeValue.id,
            type: "sign_in",
          });
        if (signoutAttendanceCodeValue)
          attendanceCodeIds.push({
            id: signoutAttendanceCodeValue.id,
            type: "sign_out",
          });
      }

      let attendance_mode = {
        entity_id: this.currentEntity.id,
        name: modeName,
        working_days: workingDaysStrings,
        from_time: moment(fromTime).format("HH:mm"),
        to_time: moment(toTime).format("HH:mm"),
        // from_time : moment.utc(fromTime).format('HH:mm'),
        // to_time : moment.utc(toTime).format('HH:mm'),
        integration_id: integrationValue ? integrationValue.id : null,
        integration_name: integrationValue ? integrationName : null,
      };

      let settings = {
        allow_late_sign_in: AllowLateSignin ? 1 : 0,
        allow_early_sign_out: AllowEarlySignout ? 1 : 0,
        allow_late_sign_in_time: AllowLateSignin
          ? signinToStartInMinutes
          : null,
        allow_early_sign_out_time: AllowEarlySignout
          ? signoutToEndInMinutes
          : null,
        allow_sign_in_specified_days: AllowOnlySpecifiedDays ? 1 : 0,
        prevent_sign_in_before_start_time: preventSigninBeforeStartTime ? 1 : 0,
        prevent_sign_in_after_end_time: preventSigninAfterEndTime ? 1 : 0,
      };

      let data = {
        attendance_mode: attendance_mode,
        settings: settings,
        attendanceCodeIds: integrationValue ? attendanceCodeIds : null,
      };

      if (update) {
        editAttendanceMode({
          id: this.attendanceModeId,
          data: data,
        });
      } else {
        addAttendanceMode(data);
      }
    },
  },
  async beforeMount() {
    // this.$store.commit("attendanceMode/setIsAvailable", false);
    await this.fetchWondeIntegrations();
    if (this.$route.query.id) {
      this.update = true;
      this.action = this.$t("common.edit");
      const currentDate = moment(new Date()).format("YYYY-MM-DD");
      this.title = this.$t("attendanceModes.grid.editMode");
      this.attendanceModeId = this.$route.query.id;
      this.modeName = this.$route.query.name;
      this.has_reasons = this.$route.query.has_reasons == "true" ? true : false;
      if (this.$route.query.working_days) {
        let days = JSON.parse(this.$route.query.working_days);
        if (days) {
          days = days.split(" - ");
          this.workingDaysOptions.map((day) => {
            days.map((value) => {
              if (value === day.label) this.daysValue.push(day.id);
            });
          });
        }
      }

      this.fromTime = new Date(currentDate + " " + this.$route.query.from_time);
      this.toTime = new Date(currentDate + " " + this.$route.query.to_time);
      if (this.$route.query.integration_id) {
        this.getWondeIntegrations?.map((integration) => {
          if (integration.id == this.$route.query.integration_id)
            this.integrationValue = integration;
        });
      }

      if (this.integrationValue) {
        this.integrationName = this.$route.query.integration_name;
        this.fetchAttendanceCodes({ id: this.integrationValue.id }).then(
          (data) => {
            this.attendanceCodeSigninOptions = data.data;
            this.attendanceCodeSignoutOptions = data.data;
            this.integrationsLoading = false;
            if (this.$route.query.attendance_codes) {
              let codes = JSON.parse(this.$route.query.attendance_codes);

              codes.map((code) => {
                if (code.pivot.action_type == "sign_in") {
                  this.signinAttendanceCodeValue = code;
                } else if (code.pivot.action_type == "sign_out") {
                  this.signoutAttendanceCodeValue = code;
                }
              });
            }
          }
        );
      }

      if (this.$route.query.settings) {
        let settings = JSON.parse(this.$route.query.settings);
        // console.log("sss", settings);
        settings.map((setting) => {
          if (setting.name == "allow_sign_in_specified_days") {
            if (setting.pivot && setting.pivot.value == 1) {
              this.AllowOnlySpecifiedDays = true;
            }
          }

          if (setting.name == "prevent_sign_in_before_start_time") {
            if (setting.pivot && setting.pivot.value == 1) {
              this.preventSigninBeforeStartTime = true;
            }
          }
          if (setting.name == "prevent_sign_in_after_end_time") {
            if (setting.pivot && setting.pivot.value == 1) {
              this.preventSigninAfterEndTime = true;
            }
          }

          if (setting.name == "allow_late_sign_in_time") {
            if (setting.pivot && setting.pivot.value) {
              this.signinToStartInMinutes = setting.pivot.value;
            }
          }
          if (setting.name == "allow_late_sign_in") {
            if (setting.pivot && setting.pivot.value == 1) {
              this.AllowLateSignin = true;
            }
          }
          if (setting.name == "allow_early_sign_out") {
            if (setting.pivot && setting.pivot.value == 1) {
              this.AllowEarlySignout = true;
            }
          }
          if (setting.name == "allow_early_sign_out_time") {
            if (setting.pivot && setting.pivot.value) {
              this.signoutToEndInMinutes = setting.pivot.value;
            }
          }
        });
      }
    }
  },
};
</script>

<style lang="scss">
.form-group .error {
  border: 1.5px solid #f46a6a !important;
}

.error-message {
  color: #f46a6a !important;
  margin-inline-start: 2rem !important;
  margin-top: 5px !important;
  font-size: 14px !important;
  font-weight: bolder;
}

.form {
  margin-bottom: 2rem;
}

.days-options,
.timepicker-inputs {
  position: relative;
}
.selected-date-value {
  input.mx-input {
    padding-inline-start: 20px !important;
    padding-top: 25px !important;
  }
}
.invalid-value-attendance {
  border: 1.5px solid #f46a6a;
  border-radius: 4px;
}
.check-host-button.custom-control.custom-checkbox {
  .custom-checkbox .custom-control-label::before {
    border: 3px solid #000000 !important;
  }
  .custom-control-label::before {
    margin-top: 5px;
  }
  .custom-control-label::after {
    margin-top: 5px;
  }
}
.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 15px;
  margin-top: 20px;
}
.days-treeselect,
.integrations-treeselect {
  position: relative;
}
.wokring-days-label,
.integrations-label {
  position: absolute;
  color: #103f5e;
  margin-top: 10px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 20px;
  z-index: 2;

  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
}

.from-to-label-one {
  position: absolute;
  color: #103f5e;
  margin-top: 10px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 20px;
  z-index: 2;

  font-size: 15px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
  margin-top: 5px;
  padding-inline-start: 7px;
}
.vue-treeselect__list-item.vue-treeselect__indent-level-0 {
  width: 420px;
}
.vue-treeselect.vue-treeselect--multi.vue-treeselect--searchable.vue-treeselect--open-below {
  width: 416px;
}
.vue-treeselect__menu {
  width: 416px;
}

.addMode-form {
  min-height: 627px !important;
  background-color: white;
  padding: 32px;
  border-radius: 8px;

  .vue-treeselect__control {
    width: 416px;
    height: 55px;
    background: #f2f2f2 !important;
    margin-bottom: 17px;
    // padding-inline-start: 4px;
    border-radius: 4px;
    border: none;
    position: relative;

    .vue-treeselect__multi-value {
      min-height: 55px !important;
      display: flex;
      flex-wrap: wrap;
      .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
        position: absolute;
        top: 20px;
        inset-inline-start: 10px;

        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
  }
  .vue-treeselect svg {
    fill: #787878;
  }
  .vue-treeselect__multi-value-item {
    cursor: pointer;
    display: inline-table;
    background: #103f5e;
    padding: 0px !important;
    border: none;
    border-radius: 6px;
    height: 39px;
    // min-width: 92px;
    color: #ffff;
    font-size: 12px;
    vertical-align: top;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
  }
  .vue-treeselect__value-remove {
    border: none !important;
    width: 33px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }

  .inputs-width {
    width: 416px;
  }

  .pre-reg-datepicker {
    input.mx-input::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      margin-inline-start: 20px;
      padding-inline-start: 10px;
      color: #787878;
    }
    .mx-input:disabled {
      &::placeholder {
        color: #787878;
        // opacity: 0.4;
      }
    }

    input.mx-input {
      background-color: #f2f2f2 !important;
      border: none !important;
      border-radius: 4px !important;
      height: 55px !important;

      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;

      /* Input text */

      color: rgba(0, 0, 0, 0.87) !important;

      // opacity: 0.8;
    }

    .mx-input-wrapper {
      padding-top: 1px !important;
      padding-inline-end: 0px !important;
      padding-bottom: 0px !important;
      padding-inline-start: 7px !important;
    }
  }

  .timepicker-inputs {
    margin-inline-start: -7px !important ;
  }

  .timepicker-width {
    width: 200px !important;
    height: 55px !important;
  }

  .mr-14 {
    margin-inline-end: 23px !important;
  }

  .addMode-seperator-line {
    height: 1px;
    width: 422px !important;
    margin: 38px 0px 28px 0px;
    background: #000000;
    opacity: 0.08;
  }

  .mode-settings-label {
    font-size: 16px;

    font-weight: 700;
    line-height: 19px;
    color: #939393;
  }

  .mt-32 {
    margin-top: 32px !important;
    margin-bottom: 0px !important;
  }

  .signinStartTimeLabel {
    width: 199px !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 188.5%;
    color: #787878;
    margin-bottom: 0px;
    // label.custom-control-label{
    //     margin-top: -7px;
    //     margin-inline-start: 10px;
    // }
  }

  .allowSigninBeforeAfterTimeLabel {
    width: 378px !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 188.5%;
    color: #787878;
    margin-bottom: 0px;
    // label.custom-control-label{
    //     margin-top: -7px;
    //     margin-inline-start: 10px;
    // }
    label.custom-control-label {
      padding-inline-start: 15px;
    }
  }

  .allowSigninBeforeAfterTimeSection {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }

  .preventSigninAfterEndTimeSection {
    margin-top: 16px !important;
    margin-bottom: 24px !important;
  }

  .signinStartTimeLabel-two {
    font-weight: 400;
    font-size: 16px;
    line-height: 188.5%;
    color: #787878;
  }

  .signin-minutes-input {
    width: 84px;
    background-color: #f2f2f2;
    height: 41px;
    border: 0px;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-start-end-radius: 0px !important;
    border-end-end-radius: 0px !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;

    color: rgba(96, 96, 96, 0.87);

    opacity: 0.8;
    text-align: center;
  }

  .minutes-label {
    border-start-end-radius: 4px;
    border-end-end-radius: 4px;
    border-start-start-radius: 0px !important;
    padding: 12px 12px 12px 12px;
    background-color: #f2f2f2;
    height: 41px;
    width: 81px;
    display: flex;
    align-items: center;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .minutes {
    border-inline-start: 1px solid #e2dede;
    /* margin-inline-start: 12px!important; */
    width: 84px;
    height: 26px;
    margin-inline-start: -12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline-start: 10px;
  }
  .signin-minutes {
    margin-inline-start: 55px;
  }

  .input-border-wrapper {
    background-color: #f2f2f2;
    overflow: hidden;
    .input-border {
      border-inline-start: 1px solid #dfdfdf;
      height: 25px;
      position: relative;
      top: 9px;
    }
  }

  .signin-start-time {
    height: 44px;
    width: 168px;
  }

  .mt-40 {
    margin-top: 40px !important;
  }

  .signin-out-note {
    width: 168px;
    height: 43px;
    margin-top: 8px;

    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #939393;
  }

  .codes-signin-out-note {
    width: 376px;
    height: 55px;
    // margin-top: 8px;

    font-weight: 400;
    font-size: 14px;
    line-height: 23.5px;
    letter-spacing: 0.25px;
    color: #939393;
    margin-inline-start: 20px;
    margin-top: -14px !important;
  }

  .signin-out-error {
    width: 168px;
    height: 43px;
    margin-top: 8px;

    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.25px;
    color: #f46a6a;
  }
}
.vue-treeselect__x-container {
  display: none;
}
span.vue-treeselect__multi-value-label {
  padding: 11px 14px;
}
.vue-treeselect__value-remove > svg {
  width: 11px;
  height: 11px;
  fill: white !important;
}
.vue-treeselect__menu {
  // max-height: 160px !important;
  border: 1px solid #ffffff;
  margin-top: 5px !important;
  border-radius: 6px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161) !important;
}
.vue-treeselect__multi-value-item:hover .vue-treeselect__value-remove {
  background: #f46a6a;
}
.vue-treeselect__multi-value-item-container {
  margin-top: 10px;
  margin-inline-start: 15px;
  margin-bottom: 5px;
}
.arrowHide {
  display: none !important;
}

.disabled-cursor {
  cursor: not-allowed;
}
.disabledValue {
  opacity: 0.8;
  cursor: not-allowed !important;
}
.disabledValueTwo {
  opacity: 0.8;
  cursor: not-allowed !important;
}
.noUserTypesInFlow {
  width: 415px;

  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  margin-bottom: 17px !important;
}
.highZIndex {
  z-index: 99;
}
.mb-20 {
  margin-bottom: 20px !important;
}
</style>

<style lang="scss" scoped>
::v-deep {
  //////////////////// closed-arrow /////////////////
  // svg.vue-treeselect__control-arrow.vue-treeselect__control-arrow--rotated{
  //     display: flex;
  // margin-inline-start: -15px;
  // margin-top: 15px;
  // // padding-inline-end: 20px;
  // // padding-inline-start: 20px;
  // }
  .integrations-options {
    position: relative;
    margin-top: 17px;
    .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      padding-top: 20px;
      padding-inline-start: 15px;
      letter-spacing: 0.25px;

      color: #787878;
    }
    .vue-treeselect__single-value {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;
      padding-top: 30px;
      padding-inline-start: 15px;
      color: #4a4a4a !important;
    }
  }
  .vue-treeselect__menu::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
  .vue-treeselect__list {
    width: 406px;
  }
  .vue-treeselect__option {
    border-top: 1px solid #ebebeb;
    padding-inline-end: 10px;
  }
  .vue-treeselect__label {
    font-size: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #787878;
    padding-inline-start: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
  }
  .vue-treeselect__list-item {
    width: 98% !important;
  }

  .vue-treeselect__list:first-of-type
    > .vue-treeselect__list-item:first-of-type
    > .vue-treeselect__option:first-of-type {
    border-top: none;
  }
  .vue-treeselect__input-container {
    font-size: 16px;
    margin-top: 15px;
    padding-inline-start: 15px;
  }
  .vue-treeselect__checkbox {
    background-color: #ffffff !important;
    padding: 5px !important;
    border: 3px solid #787878 !important;
    border-radius: 3px !important;
    width: 17px !important;
    height: 17px !important;
  }
  .vue-treeselect__checkbox--checked {
    background-color: #787878 !important;
    border: solid #787878 3px !important;
  }
  .vue-treeselect__check-mark,
  .vue-treeselect__minus-mark {
    background-color: #787878 !important;
    border: none !important;
  }
  .vue-treeselect--disabled .vue-treeselect__placeholder {
    opacity: 0.3;
    // margin-inline-start: 20px;
  }
  .disabled-svg {
    opacity: 0.3;
  }
}
</style>
